<template>
  <button
    v-if="breadcrumbs.length > 0"
    type="button"
    class="
      group
      mr-6
      flex
      items-center
      space-x-2
      border-2
      rounded-full
      shadow-sm
      pr-3
      hover:bg-cyan-600 hover:border-transparent
      focus:outline-none
      transition
      duration-150
    "
    @click="clickBack"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="
        h-6
        w-6
        text-gray-400
        group-hover:text-white
        transition
        duration-150
      "
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
      />
    </svg>
    <span
      class="
        text-base text-gray-900
        group-hover:text-white
        transition
        duration-150
      "
      >Back</span
    >
  </button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState(['breadcrumbs']),

  methods: {
    clickBack() {
      if (this.breadcrumbs.length === 1) {
        this.$router.push('/')
      } else {
        const routeName =
          this.breadcrumbs[this.breadcrumbs.length - 2].routeName
        this.$router.push({ name: routeName })
      }
    },
  },
}
</script>
